// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-5b8f093f] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.mention-bubble--primary .mention-bubble__content[data-v-5b8f093f] {
  color: var(--color-primary-element-text);
  background-color: var(--color-primary-element);
}
.mention-bubble__wrapper[data-v-5b8f093f] {
  position: relative;
  max-width: 150px;
  height: 18px;
  vertical-align: text-bottom;
  display: inline-flex;
  align-items: center;
}
.mention-bubble__content[data-v-5b8f093f] {
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  max-width: 100%;
  height: 20px;
  -webkit-user-select: none;
  user-select: none;
  padding-inline: 2px 6px;
  border-radius: 10px;
  background-color: var(--color-background-dark);
}
.mention-bubble__icon[data-v-5b8f093f] {
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: var(--color-background-darker);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px;
}
.mention-bubble__icon--with-avatar[data-v-5b8f093f] {
  color: inherit;
  background-size: cover;
}
.mention-bubble__title[data-v-5b8f093f] {
  overflow: hidden;
  margin-inline-start: 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mention-bubble__title[data-v-5b8f093f]::before {
  content: attr(title);
}
.mention-bubble__select[data-v-5b8f093f] {
  position: absolute;
  z-index: -1;
  inset-inline-start: -100vw;
  width: 1px;
  height: 1px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcMentionBubble-CB5c5ue2.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gDAAgD;EAChD,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-5b8f093f] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.mention-bubble--primary .mention-bubble__content[data-v-5b8f093f] {\n  color: var(--color-primary-element-text);\n  background-color: var(--color-primary-element);\n}\n.mention-bubble__wrapper[data-v-5b8f093f] {\n  position: relative;\n  max-width: 150px;\n  height: 18px;\n  vertical-align: text-bottom;\n  display: inline-flex;\n  align-items: center;\n}\n.mention-bubble__content[data-v-5b8f093f] {\n  display: inline-flex;\n  overflow: hidden;\n  align-items: center;\n  max-width: 100%;\n  height: 20px;\n  -webkit-user-select: none;\n  user-select: none;\n  padding-inline: 2px 6px;\n  border-radius: 10px;\n  background-color: var(--color-background-dark);\n}\n.mention-bubble__icon[data-v-5b8f093f] {\n  position: relative;\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  background-color: var(--color-background-darker);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 12px;\n}\n.mention-bubble__icon--with-avatar[data-v-5b8f093f] {\n  color: inherit;\n  background-size: cover;\n}\n.mention-bubble__title[data-v-5b8f093f] {\n  overflow: hidden;\n  margin-inline-start: 2px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.mention-bubble__title[data-v-5b8f093f]::before {\n  content: attr(title);\n}\n.mention-bubble__select[data-v-5b8f093f] {\n  position: absolute;\n  z-index: -1;\n  inset-inline-start: -100vw;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
